import React from 'react'
import Image from '../../../images/buyerpolicies/Personal Information.png'

const Personal_information = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Personal Information</h2>
            <p>When you decide to choose us for your online shopping, it is our responsibility to protect your security and safety. We promise to take optimum care to protect all of your private information and keep it confidential at all costs. In case, something is seriously wrong, you can get it changed or altered immediately.</p>
        </div>
      </div>
    </div>
  )
}

export default Personal_information
